@if (editMode && formGroup && !formGroup.get(this.fieldConfig.name)?.disabled) {
  <div>
    <mat-form-field [formGroup]="formGroup" class="example-full-width">
      <div class="content-upload">
        <label
          class="uploader"
          ondragover="return false;"
          [ngClass]="{ loaded: loadedFile }"
          [style.borderColor]="dragging ? activeColor : baseColor"
          (dragenter)="handleDragEnter()"
          (dragleave)="handleDragLeave()"
          (drop)="handleDrop($event)">
          @for (file of files; track file) {
            <p [class.loaded]="loadedFile">{{ file.name }}</p>
          }
          <input readonly formControlName="{{ fieldConfig.name }}" matInput />
          @if (!loadedFile) {
            <button type="button" mat-button (click)="fileInput.click()" class="add-file-button">Add file</button>
          }
          @if (loadedFile) {
            <button type="button" mat-mini-fab color="primary" (click)="fileInput.click()" class="edit-button">
              <mat-icon>edit</mat-icon>
            </button>
          }
          <input #fileInput type="file" name="file" [accept]="fileSuffix" (change)="onFilesAdded()" />
        </label>
      </div>
    </mat-form-field>
  </div>
} @else {
  <div>
    @if (filename !== undefined) {
      <div>{{ filename }}</div>
    }
    @if (filename === undefined) {
      <div>No file</div>
    }
  </div>
}
